import React from 'react'
import _ from 'lodash'
import Griddle from 'griddle-react'
import { Link } from 'react-router'
import * as request from 'superagent'
import NoCache from 'superagent-no-cache'
import { getToken } from '../../Commons/Authentication'
import NavigationBar from '../../Commons/NavigationBar'
import { ToastContainer, ToastMessage } from 'react-toastr'
import SearchImage from '../../../img/icons/general-icons/search_icon.png'
import LinkUpdateType from './LinkUpdateType'
import NotDataAvailable from './NotDataAvailable'
import EditIcon from '../../../img/icons/general-icons/icon_edit.png'
import TypeIcon from '../../../img/icons/general-icons/add_user_icon.png'

const ToastMessageFactory = React.createFactory(ToastMessage.animation)

export default class SearchType extends React.Component {
  constructor (props) {
    super(props)
    this.state = ({ typeList: [], showTable: true })
    this.listType()
  }

  listType () {
    request
    .get('api/v1/type/')
    .set('Authorization', 'Bearer ' + getToken())
    .use(NoCache)
    .set('Accept', 'application/json')
    .end((err, res) => {
      if (res.statusCode === 200) {
        this.setState({ typeList: res.body })
      } else {
        if (err) {
          this.refs.container.error('Algo inesperado ocurrió, no se encontraron tipos de afiliación', '', {
            closeButton: true
          })
        }
      }
    })
  }

  showTypeTable () {
    let val = this.refs.query.value
    let url = `api/v1/type/typeahead?nombre=${val}`
    request
    .get(url)
    .set('Authorization', 'Bearer ' + getToken())
    .use(NoCache)
    .set('Accept', 'application/json')
    .end((err, res) => {
      if (res.statusCode === 200) {
        this.setState({ typeList: res.body })
        this.showGroupTable()
      } else {
        if (err) {
          this.refs.container.error('No se encontro información de tipos', '', {
            closeButton: true
          })
        }
      }
    })
  }
  findTypeAhead () {
    let val = this.refs.query.value
    let url = `api/v1/type/typeahead?nombre=${val}`
    request
    .get(url)
    .set('Authorization', 'Bearer ' + getToken())
    .use(NoCache)
    .set('Accept', 'application/json')
    .end((err, res) => {
      if (err) {
        this.refs.container.error('No se encontro información de tipos', '', {
          closeButton: true
        })
      } else {
        this.setState({ typeList: res.body })
        this.showEpsTable()
      }
    })
  }

  render () {
    document.title = 'Listado de Tipos de Afiliación - CORE 3.0'
    var information = this.state.typeList
    var typeData = []
    var columnsData = [
      {
        'columnName': 'Nombre'
      },
      {
        'columnName': 'Estado'
      },
      {
        'columnName': ' ',
        'customComponent': LinkUpdateType
      }
    ]
    _.forEach(information, (key, vals) => {
      typeData.push({
        'Nombre': key.nombre,
        'Estado': key.status ? 'activo' : 'inactivo',
        ' ': EditIcon
      })
    })
    return (
      <div className='form-page-container'>
        <ToastContainer toastMessageFactory={ToastMessageFactory} ref='container' className='toast-top-right' />
        <NavigationBar />
        <div className='form-field-container'>
          <img className='form-field-image' src={SearchImage}/>
          <input id='searchType' ref='query' className='form-input-search' onChange={(e) => { this.findTypeAhead() }} type='text' placeholder='Buscar Tipo....' />
        </div>
        <div className='table-container'>
          <Griddle tableClassName='table' showFilter={false} showSettings={false} customNoDataComponent={NotDataAvailable} columnMetadata={columnsData} results={typeData} resultsPerPage={10} enableInfiniteScroll={true} bodyHeight={350}/>
        </div>
        <div className='form-field-new-type'>
          <img className='form-field-image' src={TypeIcon} />
          <Link className='form-link-new-type' to={'/type'}>Ingresar nuevo Tipo</Link>
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/Type/SearchType/SearchComponent.js